/**
 * Checks if a given input is a valid regular expression pattern.
 * It tries to create a new `RegExp` object with the provided `pattern` and returns
 * `true` if the pattern is valid, and `false` if it is not.
 * @param pattern - Given user input to be validated
 * @returns `true` if the input `pattern` is a valid regular expression pattern,
 * and `false` if it is not valid.
 */
export const isValidRegex = (pattern) => {
  if(!pattern) {
    return false;
  }
  try {
    new RegExp(pattern);

    return true;
  } catch (e) {
    return false;
  }
};
